import { useState } from "react";

import { remapNMEASelectionIndices, type INMEARow } from "./NMEAAutomationModal.utils";

interface Props {
  sectionIndex: number;
  rows: INMEARow[];
  setSelectedSections: (selectedSections: number[][]) => void;
}

export const useNMEASectionSort = ({
  sectionIndex,
  rows,
  setSelectedSections,
}: Props) => {
  const [sortAscending, setSortAscending] = useState(false);

  const handleToggleSectionSort = () => {
    const nextAscending = !sortAscending;

    setSelectedSections(prev => {
      const updatedSections = [...prev];
      const sectionSelections = updatedSections[sectionIndex] ?? [];

      updatedSections[sectionIndex] = remapNMEASelectionIndices(
        rows,
        sectionSelections,
        nextAscending,
      );

      return updatedSections;
    });
    setSortAscending(nextAscending);
  };

  return {
    sortAscending,
    handleToggleSectionSort,
  };
};
